import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTotalActionsOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 22,
	viewBox: "0 0 23 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4001 9.16661C15.4026 10.1345 15.1764 11.0893 14.7401 11.9533C14.2226 12.9886 13.4272 13.8594 12.4429 14.4681C11.4585 15.0768 10.3241 15.3995 9.16671 15.4C8.1988 15.4025 7.24398 15.1763 6.38003 14.74L2.20001 16.1333L3.59335 11.9533C3.15697 11.0893 2.93082 10.1345 2.93335 9.16661C2.9338 8.00922 3.25647 6.87482 3.86521 5.89046C4.47396 4.90611 5.34475 4.11067 6.38003 3.59325C7.24398 3.15687 8.1988 2.93072 9.16671 2.93325H9.53338C11.0619 3.01758 12.5056 3.66274 13.5881 4.74522C14.6706 5.82769 15.3157 7.27141 15.4001 8.79994V9.16661Z",
			stroke: "#454545",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0003 14.2999C22.0003 18.5525 18.5529 21.9999 14.3003 21.9999C10.0477 21.9999 11.3668 19.2858 11.3668 15.0332C-0.733378 7.69988 11.5141 7.69989 15.7667 7.69989C20.0193 7.69989 22.0003 10.0473 22.0003 14.2999Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 9.53326L13.5639 14.2081",
			stroke: "#454545",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2007 20.9738L22.0001 9.53394H8.80005L13.5639 14.2087L15.2007 20.9738Z",
			stroke: "#454545",
			strokeWidth: 2,
			strokeLinejoin: "round"
		})
	]
});
export default SvgTotalActionsOutline;
